import { useNavigate, useLocation } from "react-router-dom";
import RequirementItem from "../atoms/RequirementItem";
import { Briefcase, GraduationCap, MapPin } from "lucide-react";
import Button from "../atoms/Button";

type JobCardProps = {
  variant?: "square" | "rectangle";
  id: number;
  title: string;
  description?: string;
  education: string;
  yearExperience: string;
  priceRange?: string;
  company?: string;
  company_logo?: string;
  location?: string;
  buttonText?: string;
};

export default function JobCard({
  variant = "square",
  id,
  title,
  description,
  education,
  yearExperience,
  priceRange,
  company,
  company_logo,
  location,
  buttonText,
}: JobCardProps) {
  const navigate = useNavigate();
  const locationPath = useLocation();
  const currentLang = locationPath.pathname.startsWith("/id") ? "id" : "en";

  const stripHtml = (html: string) =>
    html.replace(/<[^>]*>?/gm, "");

  const handleViewDetail = () => {
    navigate(`/${currentLang}/jobs/${id}`);
  };

  return (
    <div
      onClick={handleViewDetail}
      className="cursor-pointer group relative flex flex-col
        rounded-2xl md:p-8 p-4 shadow-md transition-all duration-300 
        min-h-[320px] hover:shadow-lg overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-left-bottom"
        style={{ backgroundImage: "url('/assets/images/card-job-hover.png')" }}
      />
      <div
        className="absolute inset-0 bg-cover bg-left-bottom opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{ backgroundImage: "url('/assets/images/card-job.png')" }}
      />

      {/* Content */}
      <div className="relative z-0 flex flex-col h-full">
        <div className="text-primary group-hover:text-white">
          <h3 className="text-lg md:text-2xl font-bold">{title}</h3>
          {company && <p className="text-sm mt-3">{company}</p>}
          {priceRange && (
            <p className="font-medium group-hover:text-[#bdbc95]">
              {priceRange}
            </p>
          )}
        </div>

        <div className="flex-grow flex flex-col justify-center">
          {/* {description && (
            <p className="text-sm md:text-base mt-3 text-font-alt group-hover:text-font-alt">
              {stripHtml(description).slice(0, 80)}…
            </p>
          )} */}

          <div className="border-t border-gray-300 my-4" />

          <div className="flex justify-between items-start">
            <div className="flex flex-col gap-2">
              <RequirementItem
                icon={<Briefcase className="w-4 h-4" />}
                text={yearExperience}
              />
              <RequirementItem
                icon={<GraduationCap className="w-4 h-4" />}
                text={education}
              />
              {location && (
                <RequirementItem
                  icon={<MapPin className="w-4 h-4" />}
                  text={location}
                />
              )}
            </div>

            {company_logo && (
              <img
                src={company_logo}
                alt="Company"
                className="w-16 h-16 object-contain rounded-md"
              />
            )}
          </div>
        </div>

        <Button
          onClick={handleViewDetail}
          textClass="text-white"
          hoverTextClass="group-hover:text-black"
          rounded="rounded-3xl"
          withArrow
          className="mt-6 pe-10 py-2 text-sm font-semibold bg-primary
            group-hover:bg-secondary transition-colors self-start"
        >
          {buttonText || "Selengkapnya"}
        </Button>
      </div>
    </div>
  );
}
